import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { fetchWithAuth } from "../api/fetchWithAuth";

const initialForm = {
  number: "",
  name: "",
  type: "",
  description: "",
  expectedResult: ""
};

function TestCaseFormModal({ show, onClose, onSaved, testCase }) {
  const isEdit = Boolean(testCase);
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    if (testCase) {
      setForm({
        number: testCase.number ?? "",
        name: testCase.name ?? "",
        type: testCase.type ?? "",
        description: testCase.description ?? "",
        expectedResult: testCase.expectedResult ?? ""
      });
    } else {
      setForm(initialForm);
    }
  }, [testCase, show]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((current) => ({
      ...current,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    const url = isEdit
      ? `/api/test-cases/${testCase.id}`
      : "/api/test-cases";
    const method = isEdit ? "PUT" : "POST";

    const res = await fetchWithAuth(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form)
    });

    if (!res.ok) {
      const error = await res.json().catch(() => null);
      alert(error?.error || "Save failed");
      return;
    }

    onSaved();
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {isEdit ? "Edit Test Case" : "Add Test Case"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <div className="row g-3">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Number</Form.Label>
                <Form.Control
                  name="number"
                  value={form.number}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Type</Form.Label>
                <Form.Control
                  name="type"
                  value={form.type}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>
          </div>

          <Form.Group className="mt-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              name="name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="description"
              value={form.description}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label>Expected result</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="expectedResult"
              value={form.expectedResult}
              onChange={handleChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default TestCaseFormModal;
